import { Colors } from '@qnpm/q-theme';
const tipColors = Colors.scenes.tipColors;
const simple = {
    backgroundColor: tipColors.simpleBackground,
    textColor: tipColors.simpleText,
    brandColor: tipColors.simpleBrand
};
const friendly = {
    backgroundColor: tipColors.friendlyBackground,
    textColor: tipColors.friendlyText,
    brandColor: tipColors.friendlyBrand
};
const powerful = {
    textColor: tipColors.powerfulText,
    backgroundColor: tipColors.powerfulBackground,
    brandColor: tipColors.powerfulBrand
};
const warning = {
    textColor: tipColors.warningText,
    backgroundColor: tipColors.warningBackground,
    brandColor: tipColors.warningBrand
};
export const TipTheme = {
    simple,
    friendly,
    powerful,
    warning
};
const VERTICAL_LAYOUT = 2;
const HORIZONTAL_LAYOUT = 1;
const CENTER_LAYOUT = 3;
const TITLE_LAYOUT = 0;
export const TipLayout = {
    TITLE_LAYOUT,
    HORIZONTAL_LAYOUT,
    VERTICAL_LAYOUT,
    CENTER_LAYOUT
};
